import React, { useState } from "react";
import YoutubeModal from "./YoutubeModal";

const Youtube = ({ customComponent, onChange, isActive, isDisabled }) => {
	const [youtubeModal, setYoutubeModal] = useState(false);

	const addYoutubeVideo = href => {
		if (onChange) onChange(href);
	};

	return (
		<>
			{youtubeModal && (
				<YoutubeModal
					youtubeModal={youtubeModal}
					setYoutubeModal={setYoutubeModal}
					addVideo={addYoutubeVideo}
				/>
			)}
			<button
				className={`editor-menu-item${isActive ? " is-active" : ""}`}
				onClick={() => setYoutubeModal(true)}
				title="Add Youtube Video"
				type="button"
				disabled={isDisabled}>
				{customComponent ? customComponent : <i className="fab fa-youtube" />}
			</button>
		</>
	);
};

export default Youtube;
